import { z } from 'zod';

export const NOTIFICATION_KINDS = [
  'approval_decision',
  'client_view',
  'approval_reminder',
] as const;
export const NotificationKindSchema = z.enum(NOTIFICATION_KINDS);
export type NotificationKind = z.infer<typeof NotificationKindSchema>;

export const CreateHotelNotificationRecipientSchema = z.object({
  email: z.string().email().max(254),
  kinds: z.array(NotificationKindSchema).min(1).max(NOTIFICATION_KINDS.length),
});
export type CreateHotelNotificationRecipient = z.infer<
  typeof CreateHotelNotificationRecipientSchema
>;

export const UpdateHotelNotificationRecipientSchema = z.object({
  kinds: z.array(NotificationKindSchema).min(1),
});
export type UpdateHotelNotificationRecipient = z.infer<
  typeof UpdateHotelNotificationRecipientSchema
>;

export interface HotelNotificationRecipient {
  id: string;
  hotelId: string;
  email: string;
  kinds: NotificationKind[];
  createdAt: string;
  updatedAt: string;
}
